var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerificationUploadIdAllDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35,
    r: 33,
    fill: "#428DFC",
    stroke: "#659FF7",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9005 23.417L42.4379 25.8796L30.7789 37.5385L27.6626 34.7927L25.0474 32.5045L20.4492 37.7564L23.0861 40.0447L28.665 44.9262L31.1058 47.0837L33.4158 44.7736L47.363 30.8265L49.8256 28.3639L44.9005 23.417Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationUploadIdAllDone);
export default __webpack_public_path__ + "static/media/verification--uploadId__allDone.a6be8371c93db85086d560f4700d29b7.svg";
export { ForwardRef as ReactComponent };